// fittingsData.js

import { 
  otvod20SnapPoints, otvod25SnapPoints, otvod25_32mmSnapPoints, otvod32SnapPoints, otvod40SnapPoints,
  otvod50SnapPoints, otvod65SnapPoints, otvod80SnapPoints, otvod100SnapPoints,
  otvod125SnapPoints, otvod150SnapPoints,
  perehod483x424SnapPoints, perehod603x483SnapPoints, perehod761x603SnapPoints,
  perehod889x761SnapPoints, perehod1143x889SnapPoints,
  bortshaiba25SnapPoints, bortshaiba32SnapPoints, bortshaiba40SnapPoints, bortshaiba50SnapPoints, bortshaiba65SnapPoints,
  bortshaiba80SnapPoints, bortshaiba100SnapPoints, bortshaiba125SnapPoints, bortshaiba150SnapPoints,
  bortshaiba200SnapPoints, bortshaiba250SnapPoints, bortshaiba300SnapPoints, bortshaiba350SnapPoints
} from '../utils/snapPointsPresets';

const fittingsData = {
  "Nippel_1.4": {
    displayName: 'Ниппель 1/4"',
    diameter: 13.7,
    length: 30,
    fileName: 'Nippel.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 13.7,
      length: 13.7,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Ниппели', // Добавляем категорию
  },
  "Nippel_3.8": {
    displayName: 'Ниппель 3/8"',
    diameter: 17.2,
    length: 30,
    fileName: 'Nippel.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 17.2,
      length: 17.2,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Ниппели', // Добавляем категорию
  },
  "Nippel_1.2": {
    displayName: 'Ниппель 1/2"',
    diameter: 21.3,
    length: 35,
    fileName: 'Nippel.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 21.3,
      length: 21.3,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Ниппели', // Добавляем категорию
  },
  "Nippel_3.4": {
    displayName: 'Ниппель 3/4"',
    diameter: 26.9,
    length: 40,
    fileName: 'Nippel.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 26.9,
      length: 26.9,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Ниппели', // Добавляем категорию
  },
  "Nippel_1": {
    displayName: 'Ниппель 1"',
    diameter: 33.7,
    length: 40,
    fileName: 'Nippel.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 33.7,
      length: 33.7,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Ниппели', // Добавляем категорию
  },
  "Nippel_1_1.4": {
    displayName: 'Ниппель 1 1/4"',
    diameter: 42.4,
    length: 50,
    fileName: 'Nippel.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 42.4,
      length: 42.4,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Ниппели', // Добавляем категорию
  },
  "Nippel_1_1.2": {
    displayName: 'Ниппель 1 1/2"',
    diameter: 48.3,
    length: 50,
    fileName: 'Nippel.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 48.3,
      length: 48.3,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Ниппели', // Добавляем категорию
  },
  "Nippel_2": {
    displayName: 'Ниппель 2"',
    diameter: 60.3,
    length: 55,
    fileName: 'Nippel.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 60.3,
      length: 60.3,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Ниппели', // Добавляем категорию
  },
  "Nippel_2_1/2": {
    displayName: 'Ниппель 2 1/2"',
    diameter: 76.1,
    length: 60,
    fileName: 'Nippel.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 76.1,
      length: 76.1,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Ниппели', // Добавляем категорию
  },
  "Nippel_3": {
    displayName: 'Ниппель 3"',
    diameter: 88.9,
    length: 68,
    fileName: 'Nippel.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 88.9,
      length: 88.9,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Ниппели', // Добавляем категорию
  },
  "Nippel_4": {
    displayName: 'Ниппель 4"',
    diameter: 114.3,
    length: 76,
    fileName: 'Nippel.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 114.3,
      length: 114.3,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Ниппели', // Добавляем категорию
  },
  "Mufta_1.4": {
    displayName: 'Муфта 1/4"',
    diameter: 17.4,
    length: 10,
    fileName: 'Mufta.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 17.4,
      length: 17.4,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Муфты', // Добавляем категорию
  },
  "Mufta_3.8": {
    displayName: 'Муфта 3/8"',
    diameter: 20.8,
    length: 10,
    fileName: 'Mufta.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 20.8,
      length: 20.8,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Муфты', // Добавляем категорию
  },
  "Mufta_1.2": {
    displayName: 'Муфта 1/2"',
    diameter: 24.5,
    length: 18,
    fileName: 'Mufta.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 24.5,
      length: 24.5,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Муфты', // Добавляем категорию
  },
  "Mufta_3.4": {
    displayName: 'Муфта 3/4"',
    diameter: 29.9,
    length: 34.5,
    fileName: 'Mufta.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 29.9,
      length: 29.9,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Муфты', // Добавляем категорию
  },
  "Mufta_1": {
    displayName: 'Муфта 1"',
    diameter: 38,
    length: 42,
    fileName: 'Mufta.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 38,
      length: 38,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Муфты', // Добавляем категорию
  },
  "Mufta_1_1.4": {
    displayName: 'Муфта 1 1/4"',
    diameter: 48,
    length: 46,
    fileName: 'Mufta.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 48,
      length: 48,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Муфты', // Добавляем категорию
  },
  "Mufta_1_1.2": {
    displayName: 'Муфта 1 1/2"',
    diameter: 53.9,
    length: 46,
    fileName: 'Mufta.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 53.9,
      length: 53.9,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Муфты', // Добавляем категорию
  },
  "Mufta_2": {
    displayName: 'Муфта 2"',
    diameter: 66,
    length: 54,
    fileName: 'Mufta.DXF',
    adjustableLength: true,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 66,
      length: 66,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Муфты', // Добавляем категорию
  },
  "Zaglushka_PR_42.4": {
    displayName: 'Заглушка прямая 42,4',
    diameter: 42.4,
    length: 2,
    fileName: 'Zaglushka_PR.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Прямые',
    weight: 0.02, // вес в кг 
  },
  "Zaglushka_PR_48.3": {
    displayName: 'Заглушка прямая 48,3',
    diameter: 48.3,
    length: 2,
    fileName: 'Zaglushka_PR.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Прямые',
    weight: 0.03, // вес в кг 
  },
  "Zaglushka_PR_60.3": {
    displayName: 'Заглушка прямая 60,3',
    diameter: 60.3,
    length: 2,
    fileName: 'Zaglushka_PR.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Прямые',
    weight: 0.05, // вес в кг 
  },
  "Zaglushka_PR_76.1": {
    displayName: 'Заглушка прямая 76,1',
    diameter: 76.1,
    length: 2,
    fileName: 'Zaglushka_PR.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Прямые',
    weight: 0.07, // вес в кг
  },
  "Zaglushka_PR_88.9": {
    displayName: 'Заглушка прямая 88,9',
    diameter: 88.9,
    length: 2,
    fileName: 'Zaglushka_PR.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Прямые',
    weight: 0.10, // вес в кг 
  },
  "Zaglushka_PR_101.6": {
    displayName: 'Заглушка прямая 101,6',
    diameter: 101.6,
    length: 3,
    fileName: 'Zaglushka_PR.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Прямые',
    weight: 0.19, // вес в кг
  },
  "Zaglushka_PR_20х20": {
    displayName: 'Заглушка прямая 20х20',
    diameter: 20,
    length: 2,
    fileName: 'Zaglushka_PR.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Прямые',
    weight: 0.01, // вес в кг
  },
  "Zaglushka_PR_25х25": {
    displayName: 'Заглушка прямая 25х25',
    diameter: 25,
    length: 2,
    fileName: 'Zaglushka_PR.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Прямые',
    weight: 0.01, // вес в кг
  },
  "Zaglushka_PR_40х40": {
    displayName: 'Заглушка прямая 40х40',
    diameter: 40,
    length: 2,
    fileName: 'Zaglushka_PR.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Прямые',
    weight: 0.03, // вес в кг
  },
  "Zaglushka_PR_50х50": {
    displayName: 'Заглушка прямая 50х50',
    diameter: 50,
    length: 2,
    fileName: 'Zaglushka_PR.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Прямые',
    weight: 0.04, // вес в кг
  },
  "Zaglushka_PR_60х60": {
    displayName: 'Заглушка прямая 60х60',
    diameter: 60,
    length: 2,
    fileName: 'Zaglushka_PR.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Прямые',
    weight: 0.06, // вес в кг
  },
  "Zaglushka_PR_80х80": {
    displayName: 'Заглушка прямая 80х80',
    diameter: 80,
    length: 2,
    fileName: 'Zaglushka_PR.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Прямые',
    weight: 0.1, // вес в кг
  },
  "Zaglushka_PR_100х100": {
    displayName: 'Заглушка прямая 100х100',
    diameter: 100,
    length: 3,
    fileName: 'Zaglushka_PR.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Прямые',
    weight: 0.24, // вес в кг
  },
  "Zaglushka_PR_150х150": {
    displayName: 'Заглушка прямая 150х150',
    diameter: 150,
    length: 3,
    fileName: 'Zaglushka_PR.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Прямые',
    weight: 0.54, // вес в кг
  },
  "Zaglushka_EL_42.4": {
    displayName: 'Заглушка эллиптическая 42,4',
    diameter: 42.4,
    length: 17,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 0.04, // вес в кг 
  },
  "Zaglushka_EL_48.3": {
    displayName: 'Заглушка эллиптическая 48,3',
    diameter: 48.3,
    length: 17,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 0.05, // вес в кг 
  },
  "Zaglushka_EL_60.3": {
    displayName: 'Заглушка эллиптическая 60,3',
    diameter: 60.3,
    length: 22,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 0.06, // вес в кг 
  },
  "Zaglushka_EL_76.1": {
    displayName: 'Заглушка эллиптическая 76,1',
    diameter: 76.1,
    length: 24,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 0.10, // вес в кг 
  },
  "Zaglushka_EL_88.9": {
    displayName: 'Заглушка эллиптическая 88,9',
    diameter: 88.9,
    length: 30,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 0.14, // вес в кг 
  },
  "Zaglushka_EL_101.6": {
    displayName: 'Заглушка эллиптическая 101,6',
    diameter: 101.6,
    length: 30,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 0.18, // вес в кг 
  },
  "Zaglushka_EL_114.3": {
    displayName: 'Заглушка эллиптическая 114,3',
    diameter: 114.3,
    length: 30,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 0.22, // вес в кг 
  },
  "Zaglushka_EL_129": {
    displayName: 'Заглушка эллиптическая 129',
    diameter: 129,
    length: 35,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 0.29, // вес в кг 
  },
  "Zaglushka_EL_139.7": {
    displayName: 'Заглушка эллиптическая 139.7',
    diameter: 139.7,
    length: 35,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 0.4, // вес в кг 
  },
  "Zaglushka_EL_159": {
    displayName: 'Заглушка эллиптическая 159',
    diameter: 159,
    length: 40,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 0.43, // вес в кг 
  },
  "Zaglushka_EL_168.3": {
    displayName: 'Заглушка эллиптическая 168,3',
    diameter: 168.3,
    length: 50,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 0.76, // вес в кг 
  },
  "Zaglushka_EL_219.1": {
    displayName: 'Заглушка эллиптическая 219,1',
    diameter: 219.1,
    length: 50,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 1.16, // вес в кг 
  },
  "Zaglushka_EL_273": {
    displayName: 'Заглушка эллиптическая 273',
    diameter: 273,
    length: 65,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 1.85, // вес в кг 
  },
  "Zaglushka_EL_323.9": {
    displayName: 'Заглушка эллиптическая 323,9',
    diameter: 323.9,
    length: 72,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 2.55, // вес в кг 
  },
  "Zaglushka_EL_355.6": {
    displayName: 'Заглушка эллиптическая 355,6',
    diameter: 355.6,
    length: 89,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 3.21, // вес в кг 
  },
  "Zaglushka_EL_406.4": {
    displayName: 'Заглушка эллиптическая 406,4',
    diameter: 406.4,
    length: 98,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 4.16, // вес в кг 
  },
  "Zaglushka_EL_508": {
    displayName: 'Заглушка эллиптическая 508',
    diameter: 508,
    length: 120,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 6.47, // вес в кг 
  },
  "Zaglushka_EL_609.6": {
    displayName: 'Заглушка эллиптическая 609.6',
    diameter: 609.6,
    length: 140,
    fileName: 'Zaglushka_EL.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Заглушки',
    subcategory: 'Эллиптические',
    weight: 9.25, // вес в кг 
  },
  "Perehod_Konc_48.3х42.4": {
    displayName: 'Переход концентрический 48,3х42,4',
    diameter: 48.3,
    length: 18,
    fileName: 'Perehod_Konc48.3х42.4.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Переходы концентрические',
    weight: 0.04, // вес в кг
    snapPoints: perehod483x424SnapPoints, // 9 точек в мм
  },
  "Perehod_Konc_60.3х48.3": {
    displayName: 'Переход концентрический 60,3х48,3',
    diameter: 60.3,
    length: 37,
    fileName: 'Perehod_Konc60.3х48.3.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Переходы концентрические',
    weight: 0.10, // вес в кг
    snapPoints: perehod603x483SnapPoints, // 9 точек в мм
  },
  "Perehod_Konc_76.1х60.3": {
    displayName: 'Переход концентрический 76,1х60,3',
    diameter: 76.1,
    length: 47,
    fileName: 'Perehod_Konc76.1х60.3.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Переходы концентрические',
    weight: 0.16, // вес в кг
    snapPoints: perehod761x603SnapPoints, // 9 точек в мм
  },
  "Perehod_Konc_88.9х76.1": {
    displayName: 'Переход концентрический 88,9х76,1',
    diameter: 88.9,
    length: 38,
    fileName: 'Perehod_Konc88.9х76.1.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Переходы концентрические',
    weight: 0.16, // вес в кг
    snapPoints: perehod889x761SnapPoints, // 9 точек в мм
  },
  "Perehod_Konc_114.3х88.9": {
    displayName: 'Переход концентрический 114,3х88,9',
    diameter: 114.3,
    length: 77,
    fileName: 'Perehod_Konc114.3х88.9.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Переходы концентрические',
    weight: 0.39, // вес в кг
    snapPoints: perehod1143x889SnapPoints, // 9 точек в мм
  },
  "Flanec_25_galv": {
    displayName: 'Фланец Ду25 (своб.оцинк.)',
    diameter: 115,
    length: 16,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 115,
      length: 115,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные оцинкованные',
    weight: 1.1, // вес в кг
  },
  "Flanec_32_galv": {
    displayName: 'Фланец Ду32 (своб.оцинк.)',
    diameter: 134,
    length: 18,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 134,
      length: 134,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные оцинкованные',
    weight: 1.41, // вес в кг
  },
  "Flanec_40_galv": {
    displayName: 'Фланец Ду40 (своб.оцинк.)',
    diameter: 142,
    length: 18,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 142,
      length: 142,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные оцинкованные',
    weight: 1.57, // вес в кг
  },
  "Flanec_50_galv": {
    displayName: 'Фланец Ду50 (своб.оцинк.)',
    diameter: 155,
    length: 14,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 155,
      length: 155,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные оцинкованные',
    weight: 1.44, // вес в кг
  },
  "Flanec_65_galv": {
    displayName: 'Фланец Ду65 (своб.оцинк.)',
    diameter: 179,
    length: 17.5,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 179,
      length: 179,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные оцинкованные',
    weight: 2.39, // вес в кг
  },
  "Flanec_80_galv": {
    displayName: 'Фланец Ду80 (своб.оцинк.)',
    diameter: 195,
    length: 20,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 195,
      length: 195,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные оцинкованные',
    weight: 3.28, // вес в кг
  },
  "Flanec_100_galv": {
    displayName: 'Фланец Ду100 (своб.оцинк.)',
    diameter: 220,
    length: 20,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 220,
      length: 220,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные оцинкованные',
    weight: 3.62, // вес в кг
  },
  "Flanec_125_galv": {
    displayName: 'Фланец Ду125 (своб.оцинк.)',
    diameter: 245,
    length: 20,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 245,
      length: 245,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные оцинкованные',
    weight: 4.17, // вес в кг
  },
  "Flanec_150_galv": {
    displayName: 'Фланец Ду150 (своб.оцинк.)',
    diameter: 285,
    length: 22,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 285,
      length: 285,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные оцинкованные',
    weight: 6.00, // вес в кг
  },
  "Flanec_200_galv": {
    displayName: 'Фланец Ду200 (своб.оцинк.)',
    diameter: 340,
    length: 22,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 340,
      length: 340,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные оцинкованные',
    weight: 8.9, // вес в кг
  },
  "Flanec_250_galv": {
    displayName: 'Фланец Ду250 (своб.оцинк.)',
    diameter: 395,
    length: 22,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 395,
      length: 395,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные оцинкованные',
    weight: 10.3, // вес в кг
  },
  "Flanec_300_galv": {
    displayName: 'Фланец Ду300 (своб.оцинк.)',
    diameter: 445,
    length: 26,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 445,
      length: 445,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные оцинкованные',
    weight: 14.0, // вес в кг
  },
  "Flanec_350_galv": {
    displayName: 'Фланец Ду350 (своб.оцинк.)',
    diameter: 505,
    length: 28,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 505,
      length: 505,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные оцинкованные',
    weight: 18.5, // вес в кг
  },
  "Flanec_25_ss": {
    displayName: 'Фланец Ду25 (своб.нерж.)',
    diameter: 115,
    length: 16,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 115,
      length: 115,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные нержавеющие',
    weight: 1.20, // вес в кг
  },
  "Flanec_32_ss": {
    displayName: 'Фланец Ду32 (своб.нерж.)',
    diameter: 140,
    length: 18,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 140,
      length: 140,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные нержавеющие',
    weight: 1.70, // вес в кг
  },
  "Flanec_40_ss": {
    displayName: 'Фланец Ду40 (своб.нерж.)',
    diameter: 150,
    length: 18,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 150,
      length: 150,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные нержавеющие',
    weight: 1.90, // вес в кг
  },
  "Flanec_50_ss": {
    displayName: 'Фланец Ду50 (своб.нерж.)',
    diameter: 165,
    length: 18,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 165,
      length: 165,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные нержавеющие',
    weight: 2.30, // вес в кг
  },
  "Flanec_65_ss": {
    displayName: 'Фланец Ду65 (своб.нерж.)',
    diameter: 185,
    length: 18,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 185,
      length: 185,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные нержавеющие',
    weight: 2.80, // вес в кг
  },
  "Flanec_80_ss": {
    displayName: 'Фланец Ду80 (своб.нерж.)',
    diameter: 200,
    length: 18,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 200,
      length: 200,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные нержавеющие',
    weight: 3.40, // вес в кг
  },
  "Flanec_100_ss": {
    displayName: 'Фланец Ду100 (своб.нерж.)',
    diameter: 220,
    length: 18,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 220,
      length: 220,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные нержавеющие',
    weight: 3.90, // вес в кг
  },
  "Flanec_125_ss": {
    displayName: 'Фланец Ду125 (своб.нерж.)',
    diameter: 250,
    length: 18,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 250,
      length: 250,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные нержавеющие',
    weight: 4.80, // вес в кг
  },
  "Flanec_150_ss": {
    displayName: 'Фланец Ду150 (своб.нерж.)',
    diameter: 285,
    length: 22,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 285,
      length: 285,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные нержавеющие',
    weight: 6.00, // вес в кг
  },
  "Flanec_200_ss": {
    displayName: 'Фланец Ду200 (своб.нерж.)',
    diameter: 340,
    length: 22,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 340,
      length: 340,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные нержавеющие',
    weight: 8.9, // вес в кг
  },
  "Flanec_250_ss": {
    displayName: 'Фланец Ду250 (своб.нерж.)',
    diameter: 395,
    length: 22,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 395,
      length: 395,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные нержавеющие',
    weight: 10.3, // вес в кг
  },
  "Flanec_300_ss": {
    displayName: 'Фланец Ду300 (своб.нерж.)',
    diameter: 445,
    length: 26,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 445,
      length: 445,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные нержавеющие',
    weight: 14.0, // вес в кг
  },
  "Flanec_350_ss": {
    displayName: 'Фланец Ду350 (своб.нерж.)',
    diameter: 505,
    length: 28,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 505,
      length: 505,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные нержавеющие',
    weight: 18.5, // вес в кг
  },
  "Flanec_25_ss_stamped": {
    displayName: 'Фланец Ду25 (своб.нерж.штамп.)',
    diameter: 115,
    length: 16,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 115,
      length: 115,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные штампованные нержавеющие',
    weight: 0.37, // вес в кг
  },
  "Flanec_32_ss_stamped": {
    displayName: 'Фланец Ду32 (своб.нерж.штамп.)',
    diameter: 140,
    length: 16.5,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 140,
      length: 140,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные штампованные нержавеющие',
    weight: 0.49, // вес в кг
  },
  "Flanec_40_ss_stamped": {
    displayName: 'Фланец Ду40 (своб.нерж.штамп.)',
    diameter: 150,
    length: 17.5,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 150,
      length: 150,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные штампованные нержавеющие',
    weight: 0.55, // вес в кг
  },
  "Flanec_50_ss_stamped": {
    displayName: 'Фланец Ду50 (своб.нерж.штамп.)',
    diameter: 165,
    length: 18,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 165,
      length: 165,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные штампованные нержавеющие',
    weight: 0.64, // вес в кг
  },
  "Flanec_65_ss_stamped": {
    displayName: 'Фланец Ду65 (своб.нерж.штамп.)',
    diameter: 185,
    length: 18,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 185,
      length: 185,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные штампованные нержавеющие',
    weight: 0.77, // вес в кг
  },
  "Flanec_80_ss_stamped": {
    displayName: 'Фланец Ду80 (своб.нерж.штамп.)',
    diameter: 200,
    length: 20,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 200,
      length: 200,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные штампованные нержавеющие',
    weight: 0.88, // вес в кг
  },
  "Flanec_100_ss_stamped": {
    displayName: 'Фланец Ду100 (своб.нерж.штамп.)',
    diameter: 220,
    length: 20,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 220,
      length: 220,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные штампованные нержавеющие',
    weight: 0.99, // вес в кг
  },
  "Flanec_125_ss_stamped": {
    displayName: 'Фланец Ду125 (своб.нерж.штамп.)',
    diameter: 250,
    length: 25,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 250,
      length: 250,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные штампованные нержавеющие',
    weight: 1.83, // вес в кг
  },
  "Flanec_150_ss_stamped": {
    displayName: 'Фланец Ду150 (своб.нерж.штамп.)',
    diameter: 285,
    length: 27,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 285,
      length: 285,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные штампованные нержавеющие',
    weight: 2.30, // вес в кг
  },
  "Flanec_200_ss_stamped": {
    displayName: 'Фланец Ду200 (своб.нерж.штамп.)',
    diameter: 340,
    length: 30,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 340,
      length: 340,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Свободные штампованные нержавеющие',
    weight: 4.44, // вес в кг
  },
  "Flanec_25_welded": {
    displayName: 'Фланец Ду25 (привар.нерж.)',
    diameter: 115,
    length: 14,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 115,
      length: 115,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Приварные нержавеющие',
    weight: 1.01, // вес в кг
  },
  "Flanec_32_welded": {
    displayName: 'Фланец Ду32 (привар.нерж.)',
    diameter: 140,
    length: 16,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 140,
      length: 140,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Приварные нержавеющие',
    weight: 1.63, // вес в кг
  },
  "Flanec_40_welded": {
    displayName: 'Фланец Ду40 (привар.нерж.)',
    diameter: 150,
    length: 16,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 150,
      length: 150,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Приварные нержавеющие',
    weight: 1.85, // вес в кг
  },
  "Flanec_50_welded": {
    displayName: 'Фланец Ду50 (привар.нерж.)',
    diameter: 165,
    length: 18,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 165,
      length: 165,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Приварные нержавеющие',
    weight: 2.30, // вес в кг
  },
  "Flanec_65_welded": {
    displayName: 'Фланец Ду65 (привар.нерж.)',
    diameter: 185,
    length: 18,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 185,
      length: 185,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Приварные нержавеющие',
    weight: 2.80, // вес в кг
  },
  "Flanec_80_welded": {
    displayName: 'Фланец Ду80 (привар.нерж.)',
    diameter: 200,
    length: 20,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 200,
      length: 200,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Приварные нержавеющие',
    weight: 3.40, // вес в кг
  },
  "Flanec_100_welded": {
    displayName: 'Фланец Ду100 (привар.нерж.)',
    diameter: 220,
    length: 20,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 220,
      length: 220,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Приварные нержавеющие',
    weight: 4.40, // вес в кг
  },
  "Flanec_125_welded": {
    displayName: 'Фланец Ду125 (привар.нерж.)',
    diameter: 250,
    length: 22,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 250,
      length: 250,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Приварные нержавеющие',
    weight: 5.50, // вес в кг
  },
  "Flanec_150_welded": {
    displayName: 'Фланец Ду150 (привар.нерж.)',
    diameter: 285,
    length: 22,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 285,
      length: 285,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Приварные нержавеющие',
    weight: 7.00, // вес в кг
  },
  "Flanec_200_welded": {
    displayName: 'Фланец Ду200 (привар.нерж.)',
    diameter: 340,
    length: 24,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 340,
      length: 340,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Приварные нержавеющие',
    weight: 8.90, // вес в кг
  },
  "Flanec_250_welded": {
    displayName: 'Фланец Ду250 (привар.нерж.)',
    diameter: 395,
    length: 26,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 395,
      length: 395,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Приварные нержавеющие',
    weight: 12.70, // вес в кг
  },
  "Flanec_300_welded": {
    displayName: 'Фланец Ду300 (привар.нерж.)',
    diameter: 445,
    length: 26,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 445,
      length: 445,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Приварные нержавеющие',
    weight: 14.00, // вес в кг
  },
  "Flanec_350_welded": {
    displayName: 'Фланец Ду350 (привар.нерж.)',
    diameter: 505,
    length: 28,
    fileName: 'Flanec.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 505,
      length: 505,
      fileName: 'Flanec(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Фланцы',
    subcategory: 'Приварные нержавеющие',
    weight: 19.00, // вес в кг
  },
  "Bortshaiba_25": {
    displayName: 'Бортшайба Ду25',
    diameter: 68,
    length: 9,
    fileName: 'Bortshaiba25.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Бортшайбы', // Добавляем категорию
    weight: 0.05, // вес в кг
    snapPoints: bortshaiba25SnapPoints, // 5 точек в мм
  },
  "Bortshaiba_32": {
    displayName: 'Бортшайба Ду32',
    diameter: 78,
    length: 10,
    fileName: 'Bortshaiba32.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Бортшайбы', // Добавляем категорию
    weight: 0.07, // вес в кг
    snapPoints: bortshaiba32SnapPoints, // 5 точек в мм
  },
  "Bortshaiba_40": {
    displayName: 'Бортшайба Ду40',
    diameter: 88,
    length: 10,
    fileName: 'Bortshaiba40.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Бортшайбы', // Добавляем категорию
    weight: 0.08, // вес в кг
    snapPoints: bortshaiba40SnapPoints, // 5 точек в мм
  },
  "Bortshaiba_50": {
    displayName: 'Бортшайба Ду50',
    diameter: 102,
    length: 10.5,
    fileName: 'Bortshaiba50.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Бортшайбы', // Добавляем категорию
    weight: 0.11, // вес в кг
    snapPoints: bortshaiba50SnapPoints, // 5 точек в мм
  },
  "Bortshaiba_65": {
    displayName: 'Бортшайба Ду65',
    diameter: 122,
    length: 11,
    fileName: 'Bortshaiba65.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Бортшайбы', // Добавляем категорию
    weight: 0.14, // вес в кг
    snapPoints: bortshaiba65SnapPoints, // 5 точек в мм
  },
  "Bortshaiba_80": {
    displayName: 'Бортшайба Ду80',
    diameter: 140,
    length: 13,
    fileName: 'Bortshaiba80.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Бортшайбы', // Добавляем категорию
    weight: 0.18, // вес в кг
    snapPoints: bortshaiba80SnapPoints, // 5 точек в мм
  },
  "Bortshaiba_100": {
    displayName: 'Бортшайба Ду100',
    diameter: 158,
    length: 16,
    fileName: 'Bortshaiba100.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Бортшайбы', // Добавляем категорию
    weight: 0.21, // вес в кг
    snapPoints: bortshaiba100SnapPoints, // 5 точек в мм
  },
  "Bortshaiba_125": {
    displayName: 'Бортшайба Ду125',
    diameter: 184,
    length: 24,
    fileName: 'Bortshaiba125.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Бортшайбы', // Добавляем категорию
    weight: 0.42, // вес в кг
    snapPoints: bortshaiba125SnapPoints, // 5 точек в мм
  },
  "Bortshaiba_150": {
    displayName: 'Бортшайба Ду150',
    diameter: 212,
    length: 17,
    fileName: 'Bortshaiba150.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Бортшайбы', // Добавляем категорию
    weight: 0.44, // вес в кг
    snapPoints: bortshaiba150SnapPoints, // 5 точек в мм
  },
  "Bortshaiba_200": {
    displayName: 'Бортшайба Ду200',
    diameter: 268,
    length: 21,
    fileName: 'Bortshaiba200.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Бортшайбы', // Добавляем категорию
    weight: 0.66, // вес в кг
    snapPoints: bortshaiba200SnapPoints, // 5 точек в мм
  },
  "Bortshaiba_250": {
    displayName: 'Бортшайба Ду250',
    diameter: 321,
    length: 21,
    fileName: 'Bortshaiba250.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Бортшайбы', // Добавляем категорию
    weight: 0.8, // вес в кг
    snapPoints: bortshaiba250SnapPoints, // 5 точек в мм
  },
  "Bortshaiba_300": {
    displayName: 'Бортшайба Ду300',
    diameter: 370,
    length: 21,
    fileName: 'Bortshaiba300.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Бортшайбы', // Добавляем категорию
    weight: 0.91, // вес в кг
    snapPoints: bortshaiba300SnapPoints, // 5 точек в мм
  },
  "Bortshaiba_350": {
    displayName: 'Бортшайба Ду350',
    diameter: 422,
    length: 20,
    fileName: 'Bortshaiba350.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Бортшайбы', // Добавляем категорию
    weight: 1.3, // вес в кг
    snapPoints: bortshaiba350SnapPoints, // 5 точек в мм
  },
  "Otvod_20": {
    displayName: 'Отвод Ду20',
    diameter: 51,
    length: 51,
    fileName: 'Otvod20.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Отводы', // Добавляем категорию
    weight: 0.11, // вес в кг
    snapPoints: otvod20SnapPoints, // 9 точек в мм
  },
  "Otvod_25": {
    displayName: 'Отвод Ду25',
    diameter: 55,
    length: 55,
    fileName: 'Otvod25.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Отводы', // Добавляем категорию
    weight: 0.14, // вес в кг
    snapPoints: otvod25SnapPoints, // 9 точек в мм
  },
  "Otvod_25_32mm": {
    displayName: 'Отвод Ду25 (32 мм)',
    diameter: 50,
    length: 50,
    fileName: 'Otvod25(32mm).DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Отводы',
    weight: 0.14, // вес в кг, как у Отвод Ду25 — заменить, если другой
    snapPoints: otvod25_32mmSnapPoints,
  },
  "Otvod_32": {
    displayName: 'Отвод Ду32',
    diameter: 70,
    length: 70,
    fileName: 'Otvod32.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Отводы', // Добавляем категорию
    weight: 0.16, // вес в кг
    snapPoints: otvod32SnapPoints, // 9 точек в мм
  },
  "Otvod_40": {
    displayName: 'Отвод Ду40',
    diameter: 81,
    length: 81,
    fileName: 'Otvod40.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Отводы', // Добавляем категорию
    weight: 0.21, // вес в кг
    snapPoints: otvod40SnapPoints, // 9 точек в мм
  },
  "Otvod_50": {
    displayName: 'Отвод Ду50',
    diameter: 105,
    length: 105,
    fileName: 'Otvod50.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Отводы', // Добавляем категорию
    weight: 0.34, // вес в кг
    snapPoints: otvod50SnapPoints, // 9 точек в мм
  },
  "Otvod_65": {
    displayName: 'Отвод Ду65',
    diameter: 134,
    length: 134,
    fileName: 'Otvod65.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Отводы', // Добавляем категорию
    weight: 0.56, // вес в кг
    snapPoints: otvod65SnapPoints, // 9 точек в мм
  },
  "Otvod_80": {
    displayName: 'Отвод Ду80',
    diameter: 160,
    length: 160,
    fileName: 'Otvod80.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Отводы', // Добавляем категорию
    weight: 0.79, // вес в кг
    snapPoints: otvod80SnapPoints, // 9 точек в мм
  },
  "Otvod_100": {
    displayName: 'Отвод Ду100',
    diameter: 210,
    length: 210,
    fileName: 'Otvod100.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Отводы', // Добавляем категорию
    weight: 1.36, // вес в кг
    snapPoints: otvod100SnapPoints, // 9 точек в мм
  },
  "Otvod_125": {
    displayName: 'Отвод Ду125',
    diameter: 260,
    length: 260,
    fileName: 'Otvod125.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Отводы', // Добавляем категорию
    weight: 2.07, // вес в кг
    snapPoints: otvod125SnapPoints, // 9 точек в мм
  },
  "Otvod_150": {
    displayName: 'Отвод Ду150',
    diameter: 313,
    length: 313,
    fileName: 'Otvod150.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Отводы', // Добавляем категорию
    weight: 4.48, // вес в кг
    snapPoints: otvod150SnapPoints, // 9 точек в мм
  },
  "Nak_Gaika_1": {
    displayName: 'Накидная гайка 1"',
    diameter: 42.64,
    length: 15,
    fileName: 'Nak_Gaika.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 42.64,
      length: 42.64,
      fileName: 'Nak_Gaika(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Накидные гайки', // Добавляем категорию
    weight: 0.04, // вес в кг
  },
  "Nak_Gaika_1_1.4": {
    displayName: 'Накидная гайка 1 1/4"',
    diameter: 53.05,
    length: 18,
    fileName: 'Nak_Gaika.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 53.05,
      length: 53.05,
      fileName: 'Nak_Gaika(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Накидные гайки', // Добавляем категорию
    weight: 0.08, // вес в кг
  },
  "Nak_Gaika_1_1.2": {
    displayName: 'Накидная гайка 1 1/2"',
    diameter: 58.86,
    length: 18,
    fileName: 'Nak_Gaika.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 58.86,
      length: 58.86,
      fileName: 'Nak_Gaika(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Накидные гайки', // Добавляем категорию
    weight: 0.09, // вес в кг
  },
  "Nak_Gaika_2": {
    displayName: 'Накидная гайка 2"',
    diameter: 75.06,
    length: 18,
    fileName: 'Nak_Gaika.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 75.06,
      length: 75.06,
      fileName: 'Nak_Gaika(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Накидные гайки', // Добавляем категорию
    weight: 0.14, // вес в кг
  },
  "Shaib_Gaika_1": {
    displayName: 'Шайба накидной гайки 1"',
    diameter: 27.51,
    length: 3,
    fileName: 'Shaib_Gaika.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Шайбы накидных гаек', // Добавляем категорию
    weight: 0.01, // вес в кг
  },
  "Shaib_Gaika_1_1.4": {
    displayName: 'Шайба накидной гайки 1 1/4"',
    diameter: 38,
    length: 3,
    fileName: 'Shaib_Gaika.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Шайбы накидных гаек', // Добавляем категорию
    weight: 0.01, // вес в кг
  },
  "Shaib_Gaika_1_1.2": {
    displayName: 'Шайба накидной гайки 1 1/2"',
    diameter: 40.37,
    length: 2.5,
    fileName: 'Shaib_Gaika.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Шайбы накидных гаек', // Добавляем категорию
    weight: 0.02, // вес в кг
  },
  "Shaib_Gaika_2": {
    displayName: 'Шайба накидной гайки 2"',
    diameter: 56.3,
    length: 3,
    fileName: 'Shaib_Gaika.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    category: 'Шайбы накидных гаек', // Добавляем категорию
    weight: 0.03, // вес в кг
  },
  "Shaib_Nar_Rezba_1": {
    displayName: 'Шайба с наружной резьбой 1"',
    diameter: 33.7,
    length: 10,
    fileName: 'Shaib_Nar_Rezba.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 33.7,
      length: 33.7,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Шайбы с наружной резьбой', // Добавляем категорию
    weight: 0.03, // вес в кг
  },
  "Shaib_Nar_Rezba_1_1.4": {
    displayName: 'Шайба с наружной резьбой 1 1/4"',
    diameter: 42.4,
    length: 10,
    fileName: 'Shaib_Nar_Rezba.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 42.4,
      length: 42.4,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Шайбы с наружной резьбой', // Добавляем категорию
    weight: 0.06, // вес в кг
  },
  "Shaib_Nar_Rezba_1_1.2": {
    displayName: 'Шайба с наружной резьбой 1 1/2"',
    diameter: 48.3,
    length: 10,
    fileName: 'Shaib_Nar_Rezba.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 48.3,
      length: 48.3,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Шайбы с наружной резьбой', // Добавляем категорию
    weight: 0.09, // вес в кг
  },
  "Shaib_Nar_Rezba_2": {
    displayName: 'Шайба с наружной резьбой 2"',
    diameter: 60.3,
    length: 10,
    fileName: 'Shaib_Nar_Rezba.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    selfFacing: {
      diameter: 60.3,
      length: 60.3,
      fileName: 'Nippel_Mufta(NS).DXF',
      adjustableLength: false,
      isDiameterFixed: true,
    },
    category: 'Шайбы с наружной резьбой', // Добавляем категорию
    weight: 0.14, // вес в кг
  },
  // Добавьте остальные фитинги с соответствующими категориями
};

export default fittingsData;
